import axios from "axios";

const popups = {
	state: {
		showLoginPopup: false,
		showRegistrationPopup: false,
		showResetPasswordPopup: false,
		showProductPopup: false,
		showSetupPinPopup: false,
		showPinLoginPopup: false,
		showUserActivationPopup: false,
		showUserDeletionPopup: false,
		showOcrPopup: false,
		showCompleteRegistrationPopup: false,
		registrationFields: null,
		alliances: [],
	},
	mutations: {
		OPEN_SETUP_PIN_POPUP(state) {
			state.showSetupPinPopup = true;
		},
		OPEN_PRODUCT_POPUP(state, data) {
			state.showProductPopup = data;
		},
		CLOSE_PRODUCT_POPUP(state) {
			state.showProductPopup = false;
		},
		OPEN_USER_ACTIVATION_POPUP(state) {
			state.showUserActivationPopup = true;
		},
		CLOSE_USER_ACTIVATION_POPUP(state) {
			state.showUserActivationPopup = false;
		},
		OPEN_USER_DELETION_POPUP(state) {
			state.showUserDeletionPopup = true;
		},
		CLOSE_USER_DELETION_POPUP(state) {
			state.showUserDeletionPopup = false;
		},
		OPEN_OCR_POPUP(state, data) {
			state.showOcrPopup = data;
		},
		CLOSE_OCR_POPUP(state) {
			state.showOcrPopup = false;
		},
		OPEN_COMPLETE_REGISTRATION_POPUP(state){
			state.showCompleteRegistrationPopup = true;
		},
		CLOSE_COMPLETE_REGISTRATION_POPUP(state){
			state.showCompleteRegistrationPopup = false;
		}
	},
	actions: {
		openLoginPopup(context) {
			context.dispatch('closePopups');
			context.state.showLoginPopup = true;
		},

		openPinLoginPopup(context) {
			context.dispatch('closePopups');
			context.state.showPinLoginPopup = true;
		},

		async openRegistrationPopup(context) {
			return new Promise(async (resolve, reject) => {
				context.dispatch('closePopups');
				let response = await axios.get('/api/registration-fields');
				if(!response || response.data.status !== 'success'){
					reject();
					return;
				}
				
				context.state.registrationFields = response.data.fields;
				context.state.alliances = response.data.alliances;

				context.rootState.app.sessionId = response.data.session_id;


				context.state.showRegistrationPopup = true;
				resolve();
			});
		},

		openResetPasswordPopup(context) {
			context.dispatch('closePopups');
			context.state.showResetPasswordPopup = true;
		},

		closePopups(context) {
			for (const [key] of Object.entries(context.state)) {
				context.state[key] = false;
			}
		},
	}
};

export default popups;